import { Box, Paper, Tab } from "@mui/material";
import { useState } from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import MyReporteesTR from "./MyReporteesTR";
import ActionRequiredTR from "./ActionRequiredTR";

const TeamReviewPage = () => {
    const [value, setValue] = useState(0);
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
            <Box sx={{ height: "calc(100vh - 155px)", overflowY: 'auto'}}>
                <Tabs 
                sx={{
                    minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                    '& .MuiTabs-indicator': {
                        width: '100%',
                        display: 'flex',
                        justifyContent: "center !important",
                    },
                }} 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    variant="scrollable"
                    orientation="horizontal"
                    allowScrollButtonsMobile={true}
                    >
                    <Tab label="Pending" {...a11yProps(0)} />
                    <Tab label="Action Completed" {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <ActionRequiredTR />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <MyReporteesTR />
                </TabPanel>
            </Box>
    )
}

export default TeamReviewPage;
